import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AnimateHeight from 'react-animate-height';
import c from 'classnames';

import {
  WysiwygField,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
} from '../../../components';

import './style.scss';

const ParagraphText = ({ entity, containerless }) => {
  const [readMoreOpened, setReadMoreOpened] = useState(false);
  const { t } = useTranslation();
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const readMore = entity.getIn(['field_read_more', 0, 'processed']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const id = entity.get('target_id');
  const duration = 333;
  const easing = 'cubic-bezier(0.65, 0, 0.35, 1)';

  const ParagraphTextColClasses = c('col-12', {
    'col-md-10 col-lg-8 offset-md-1 offset-lg-2': !containerless,
  });

  const readMoreClasses = c('ParagraphText__read_more', {
    'ParagraphText__read_more--open': readMoreOpened,
  });

  return (
    <Container>
      <div className="row">
        <div className={ParagraphTextColClasses}>
          <div className="ParagraphText">
            <div className="ParagraphText__inner">
              {title && (
                <h2 className="ParagraphText__title">{title}</h2>
              )}
              <div className="ParagraphText__inner__content">
                <div className="ParagraphText__inner__content__body">
                  <WysiwygField
                    property="schema:text"
                    html={body}
                    key={`paragraph:${id}`}
                  />

                  {readMore && (
                    <>
                      <div className={readMoreClasses}>
                        <AnimateHeight
                          duration={duration}
                          easing={easing}
                          height={readMoreOpened ? 'auto' : 60}
                        >
                          <WysiwygField
                            property="schema:text"
                            html={readMore}
                            key={`paragraph:${id}`}
                          />
                        </AnimateHeight>
                      </div>
                      <div className="ParagraphText__read_more__button" onClick={() => { setReadMoreOpened(!readMoreOpened); }}>{readMoreOpened ? t('text_paragraph.read_less') : t('text_paragraph.read_more')}</div>
                    </>
                  )}
                </div>
              </div>
              {linkTitle && linkUri && (
                <div className="ParagraphText__inner__button">
                  <ButtonWrapper type="tertiary" href={linkUri}>{linkTitle}</ButtonWrapper>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphText;
